import React from "react";
import { Outlet } from "react-router-dom";
import { Provider } from "react-redux";
import type { Store } from "@reduxjs/toolkit";
import { ToastContainer } from "react-toastify";

import { OrgProvider } from "../../features/organization/OrganizationProvider";
import AuthBootstrap from "../../features/auth/AuthBootstrap";
import SurveyBootstrap from "../../features/survey/SurveyBootstrap";
import { CoachProvider } from "../../features/coach/contexts/CoachProvider";
import { TeamProvider } from "../../features/TeamcompositeResults/contexts/TeamContext";

export default function AppProviders({ store }: { store: Store }) {
  return (
    <Provider store={store}>
      <OrgProvider>
        <AuthBootstrap>
          <CoachProvider>
            <SurveyBootstrap>
              <TeamProvider>
                <ToastContainer position="top-right" autoClose={3000} />
                <Outlet />
              </TeamProvider>
            </SurveyBootstrap>
          </CoachProvider>
        </AuthBootstrap>
      </OrgProvider>
    </Provider>
  );
}
